// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hkOx","controls":"styles_controls__1XyL6","charLimit":"styles_charLimit__3q9WX","input":"styles_input__11l21","send":"styles_send__30SnY"};